"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberingStyleSchema = exports.NUMBERING_STYLES = void 0;
exports.computeHeadingNumbers = computeHeadingNumbers;
const zod_1 = require("zod");
/**
 * SECTION NUMBERS ARE DERIVED, NEVER STORED.
 *
 * Numbers used to be typed into heading text — 1,141 of them across the corpus.
 * That meant inserting a clause at position 3 required renumbering every heading
 * below it by hand, which is how a contract ends up with two section 7s.
 *
 * Computing them means a heading stores only its words, and the numbering is a
 * property of position. It also keeps the diff honest: moving a clause changes
 * its number without changing its text, so the diff shows a move rather than a
 * rewrite of two headings.
 */
exports.NUMBERING_STYLES = ['none', 'decimal', 'legal'];
exports.NumberingStyleSchema = zod_1.z.enum(exports.NUMBERING_STYLES);
/**
 * Returns a map of block id → rendered number, e.g. `"1."` or `"2.3"`.
 *
 * Level 1 is the DOCUMENT TITLE and is never numbered — every document in the
 * corpus opens with exactly one `h1` carrying its title, and "1. Equipment Lease
 * Agreement" is not what anyone wants.
 *
 * A heading id absent from the map renders with no number. That is how `none`
 * works, and it is also the safe answer for anything unnumberable.
 */
function computeHeadingNumbers(blocks, style) {
    const out = new Map();
    if (style === 'none')
        return out;
    let major = 0;
    let minor = 0;
    for (const b of blocks) {
        if (b.type !== 'heading')
            continue;
        if (b.level === 1)
            continue; // the document title
        if (b.level === 2) {
            major += 1;
            minor = 0;
            out.set(b.id, `${major}.`);
            continue;
        }
        // level 3
        if (style === 'decimal')
            continue; // decimal numbers level 2 only
        minor += 1;
        // A level 3 before any level 2 yields `0.1` rather than throwing: a
        // half-written draft must still render.
        out.set(b.id, `${major}.${minor}`);
    }
    return out;
}
//# sourceMappingURL=sectionNumbering.js.map